<template>
  <router-view/>
</template>

<style lang="scss">
:root {
  // color-scheme: light dark;

  --text-color: #2a2a2a;
  --bg-color: #fafafa;
  --button-bg-color: #fafafa;

  --gray-text-color: #6a6c81;
  --green-text-color: #1d8d1d;
  --orange-text-color: #ce7e22;
  --purple-text-color: #8c31af;
  --red-text-color: #aa2530;
}

@media (prefers-color-scheme: dark) {
  :root {
    --text-color: rgb(201, 195, 195);
    --bg-color: #121212;
    --button-bg-color: #e0e4ff;
  }
}

@media (prefers-color-scheme: light) {
  :root {
    --text-color: #2a2a2a;
    --bg-color: #fafafa;
    --button-bg-color: #e3eaf5;
  }
}

html,
body,
#app {
  height: 100%;
}

body {
  background: var(--bg-color);
}

#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.is-clickable {
  cursor: pointer;
}

.is-hidden {
  display: none;
  visibility: hidden;
  opacity: 0;
}
</style>
